<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <ng-template [ngTemplateOutlet]="searchFrom"></ng-template>
    <ng-template [ngTemplateOutlet]="seriesList"></ng-template>
    <ng-template [ngTemplateOutlet]="finishedSeriesList"></ng-template>
  </app-page-template>

  <ng-template #searchFrom>
    <div
      class="px-0 px-md-5 d-flex gap-3 flex-column flex-md-row justify-content-center align-items-baseline align-items-lg-center filter-box mb-4">
      <div class="search-wrapper">
        <app-search [searchBarClass]="'extra-small'" (searchQuery)="handleInput($event)" [inputValue]="name"
                    [placeholder]="t('search.placeholder.races')"/>
      </div>
      <form #filterRacesForm="ngForm" class="filter-form">
        <div class="explore-filter__grid">
          <div class="explore-filter__grid-inner">
            <div class="d-flex gap-3">
              <div class="flex-grow-1 flex-lg-grow-0">
<!--                <app-date-range-selector (dateChanged)="dateChanged($event)"-->
<!--                                         [toDate]="dateTo"-->
<!--                                         [fromDate]="dateFrom"/>-->
              </div>
              @if (leaguesCountries.length > 0) {
                <div class="flex-grow-1 flex-lg-grow-0 w-180">
                  <app-select
                    [hasDefault]="true"
                    [items]="leaguesCountries"
                    [ngModel]="countryId"
                    [defaultValue]="undefined"
                    [defaultLabel]="t('explore.countries')"
                    labelKey="name"
                    valueKey="id"
                    (ngModelChange)="onCountrySelect($event)"
                    [fullWidthDropdown]="true"
                    [isDropdownListFullWidth]="true"
                    name="countrySelect"
                    [isSmallDropdown]="true"
                    [isDarkDropdown]="true"
                  >
                  </app-select>
                </div>
              }
              @if (leaguesSports.length > 0) {
                <div class="w-180">
                  <app-select
                    [hasDefault]="true"
                    [items]="leaguesSports"
                    [ngModel]="sportId"
                    [defaultValue]="undefined"
                    [defaultLabel]="t('explore.sports')"
                    labelKey="id"
                    valueKey="id"
                    labelKeyPrefix="app.common.sports."
                    (ngModelChange)="onSportSelect($event)"
                    [fullWidthDropdown]="true"
                    [isDropdownListFullWidth]="true"
                    name="sportSelect"
                    [isSmallDropdown]="true"
                    [isDarkDropdown]="true"
                  >
                  </app-select>
                </div>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
    <app-loader [isLoading]="isLoading"></app-loader>
  </ng-template>

  <ng-template #seriesList>
    <div class="padding-bottom-92">
      <section class="next-race-section upper-section-background">
        <div class="container">
          <app-section-subtitle [subtitle]="t('league.active.and.upcoming')"/>
          <section>
            @if (getActiveLeagues().length > 0) {
              <div>
                <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                  @for (league of getActiveLeagues();track league) {
                    <div class="col mb-4">
                      <app-league-grid-item-with-image (click)="goToSeriesDetailsPage(league)" [league]="league"
                                                       [countries]="leaguesCountries"
                                                       [isFinishedLeague]="false"
                                                       [languages]="languages" [favoriteItems]="favoriteItems"/>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <app-empty-state/>
            }
          </section>
        </div>
      </section>
      @if (listOfLeagues.length > 0 && showFabButton) {
        <div (click)="scrollToTop()" class="scroll-to-top">
          <i class="bi bi-arrow-up"></i>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #finishedSeriesList>
    <div class="padding-bottom-92 pt-62-32 pb-300-100">
      <section class="next-race-section upper-section-background">
        <div class="container">
          <app-section-subtitle [subtitle]="t('app.common.finished')"/>
          <section>
            @if (getFinishedLeagues().length > 0) {
              <div>
                <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                  @for (league of getFinishedLeagues();track league) {
                    <div class="col mb-4">
                      <app-league-grid-item-with-image (click)="goToSeriesDetailsPage(league)" [league]="league"
                                                       [countries]="leaguesCountries"
                                                       [isFinishedLeague]="true"
                                                       [languages]="languages" [favoriteItems]="favoriteItems"/>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <app-empty-state/>
            }
          </section>
        </div>
      </section>
      @if (listOfLeagues.length > 0 && showFabButton) {
        <div (click)="scrollToTop()" class="scroll-to-top">
          <i class="bi bi-arrow-up"></i>
        </div>
      }
    </div>
  </ng-template>
</ng-container>
